/**
 * @generated SignedSource<<22bc49ea9bdf68822c534ad92f567cac>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation$variables = Record<PropertyKey, never>;
export type IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation$data = {
  readonly createGithubPermissionUpdateLink: {
    readonly permissionUpdateLink: string;
  };
};
export type IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation = {
  response: IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation$data;
  variables: IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "CreateGitHubPermissionUpdateLinkPayload",
    "kind": "LinkedField",
    "name": "createGithubPermissionUpdateLink",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "permissionUpdateLink",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "4bae6fbfa8327a3c1c376b27f9f101ee",
    "id": null,
    "metadata": {},
    "name": "IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationsSectionCreateGitHubPermissionUpdateLinkMutation {\n  createGithubPermissionUpdateLink {\n    permissionUpdateLink\n  }\n}\n"
  }
};
})();

(node as any).hash = "ec6735e9703ff37d2bf0762816917b54";

export default node;
